


























































































import { defineComponent } from '@vue/composition-api';
import { accessor } from '../store';

export default defineComponent({
  data() {
    return {
      reservedNum: '',
      petitionName: '',
      wasteHandle: '',
      sector: '',
      permissionLimit: '',
      contactNumber: '',
      petitionOfficer: '',
      petitionPlace: '',
      petitionType: '',
      petitionTypeDisp: '',
      reservedDate: '',
      reservedTimeSpot: '',
      petitionTel: '',
      classObject: 'compleNew'
    };
  },
  mounted() {
    const resultData = this.$route.query.resultData;
    this.reservedNum = resultData.reservedNum;
    this.petitionName = resultData.petitionName;
    this.wasteHandle = resultData.wasteHandleStr;
    this.sector = resultData.sectorStr;
    this.permissionLimit = resultData.permissionLimit;
    this.contactNumber = resultData.contactNumber;
    this.petitionPlace = resultData.petitionPlace;
    this.petitionType = resultData.petitionType;
    this.petitionTypeDisp = resultData.petitionTypeDisp;
    this.reservedDate = resultData.reservedDate;
    this.reservedTimeSpot = resultData.reservedTimeSpot;
    this.petitionOfficer = resultData.petitionOfficer;
    this.petitionTel = accessor.newTel;
    this.classObject = this.$route.query.classObject;

    // storeを初期化
    accessor.resetState();
  }
});
